import ShareholderAnalysisFactory from '../_commonComponents/ShareholderAnalysis/ShareholderAnalysisFactory';

const l10nPrefix = 'country';
const primaryDataKey = 'country';

export default ShareholderAnalysisFactory({ primaryDataKey, l10nPrefix });
